import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import Layout from '../../Layout/Layout'
import Breadcrumb from '../../common/Breadcrumb'
import PlayListDetails from '../Videos/PlayListDetails'
import AnalyticsService from '../../../services/analytics'
import { set } from 'lodash'

function PlayList() {
  const { id, season } = useParams();
  const [playListId, setPlayListId] = useState(null);
  const [seasonId, setSeasonId] = useState(null);

  useEffect(() => {
    AnalyticsService.sendPageView(window.location.pathname);
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    setPlayListId((id === 'merkozesek') ? 'matches' : 'highlights');
    setSeasonId(season);
  }, [id, season])

  const getTitle = () => {
    if (id === 'osszefoglalok') {
      const seasonTitle = (seasonId) ? seasonId : '2025-26';
      return `${seasonTitle} évad összefoglalók`;
    } else {
      return 'Mérkőzések';
    }
  }

  if (!playListId) return <div>Betöltés...</div>

  return (
    <Layout type="slim" cssClassName="article-container">
      <Breadcrumb />

      <section className="main-content playlist-container">
        <div className="container">
          <h3 className="video-header">{getTitle()}</h3>
          <PlayListDetails id={playListId} season={seasonId} amount={50} />
        </div>
      </section>
    </Layout>
  )
}

export default PlayList
